import { render, staticRenderFns } from "./add-projectfilekind.vue?vue&type=template&id=98805836&scoped=true&"
import script from "./add-projectfilekind.vue?vue&type=script&lang=js&"
export * from "./add-projectfilekind.vue?vue&type=script&lang=js&"
import style0 from "./add-projectfilekind.vue?vue&type=style&index=0&id=98805836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98805836",
  null
  
)

export default component.exports